import { createSlice } from "@reduxjs/toolkit";

export const contextBuilderSlice = createSlice({
  name: "contextBuilder",
  initialState: {
    load: false,
    page: "default",
    prevPage: "default",
    pos: { x: window.innerWidth - 325, y: 100 },
    openContext: true
  },
  reducers: {
    setLoading(state, action) {
      state.load = action.payload
    },
    changePage(state, action) {
      state.page = action.payload
    },
    setPrevPage(state, action) {
      // if a page is clicked twice, it won't update prev page
      if (state.page !== action.payload) {
        state.prevPage = action.payload
      }
    },
    setPos(state, action) {
      state.pos = action.payload
    },
    setopenContext(state, action) {
      state.openContext = action.payload
    }
  }
})